<template>
  <button
    type="button"
    :class="{'back-to-top-button--show': isVisible && !isFooterVisible}"
    :aria-label="ariaLabel"
    class="ds-button-icon ds-button-icon--white back-to-top-button"
    data-j-back-top-button
    @click="handleScrollToTop"
  >
    <DsIcon
      category="arrows"
      name="arrowTopSmall"
    />
  </button>
</template>

<script setup>
import { DsIcon } from 'awds'

defineProps({
  ariaLabel: { type: String, required: true },
  isVisible: { type: Boolean, default: false }
})

const observer = ref(null)
const isFooterVisible = ref(false)

onMounted(() => {
  createFooterObserver()
})

onBeforeUnmount(() => {
  observer.value.disconnect()
})

const handleScrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth'
    })
  }
}

const createFooterObserver = () => {
  observer.value = new IntersectionObserver(handleFooterIntersection)
  observeFooterIntersection()
}

const observeFooterIntersection = () => {
  const footerElement = document.querySelector('footer')
  observer.value.observe(footerElement)
}

const handleFooterIntersection = (entries) => {
  isFooterVisible.value = !!(entries?.[0]?.isIntersecting)
}

</script>

<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';

.back-to-top-button {
  background-color: $color-white;
  bottom: 0;
  box-shadow: 0 $spacing-24 $spacing-48 0 rgba(0, 17, 44, 0.1);
  display: none;
  margin-bottom: $spacing-24;
  opacity: 0;
  position: fixed;
  right: $spacing-24;

  &--show {
    animation: visible 0.5s forwards;
    display: inline-flex;
  }

  @keyframes visible {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}
</style>
